// PatientData Model
import { Model } from '@vuex-orm/core'

export default class LabBtrChoice extends Model {
	// This is the name used as module name of the Vuex Store.
	static entity = 'LabBtrChoices'

	// List of all fields (schema) of the post model. `this.attr` is used
	// for the generic field type. The argument is the default value.
	static fields() {
		return {
			id: this.attr(null),
			btr_choice_id: this.attr(null),
			btr_choice_name: this.attr(null),
			btr_choice_other: this.attr(null),
			btr_choice_status: this.attr(null),
			datas: this.attr(null),
			list_orderby: this.number(0)
		}
	}
}
